import React from 'react';
import AdsModalForm from './form';
import {getAdsModalItem, updateAdsModalItem,updateProductItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from '../Coupons/pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class EditAdsModal extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const ads_id = this.props.match.params.id;
        getAdsModalItem(ads_id, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const ads_id = this.props.match.params.id;
        const formData = normalizer(values, this.state.data);
        updateAdsModalItem(ads_id, formData, () => {
            notification.open({
                message: `تبلیغ با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({submitted: false});
            history.item.push(`/ads-modal`);
        })
    }
    render() {
        if(!this.state.data.id){
            return (<div>لطفا منتظر بمانید</div>);
        }
        return (<div><AdsModalForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditAdsModal;


// WEBPACK FOOTER //
// ./src/containers/AdsModal/edit.js